import React from 'react'

export default function About() {
    return (
        <div>

<section id="header" className="d-flex align-items-center">
            <div className="containter-fluid">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row">
                            <div className="col-md-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex justify-content-center flex-column">
                                <h1>Grow with <strong className="brand-name">Arnican</strong></h1>
                                <h4 className="my-3">
                                    We specialise in financial management services
                                </h4>
                                {/* <div className="mt-3">
                                    <NavLink to="/services" className="btn-get-started">Get Started</NavLink>
                                </div> */}
                            </div>

                            <div className="col-lg-6 pt-5 pt-lg-0 order-1 order-lg-2 header-img">
                            <h3 className="card-title">About Us</h3>
    <h6 className="card-subtitle mb-2 text-muted">Arnican Tax & Accounting Services</h6>
    <p className="card-text"><i>Arnican Tax & Accounting is a complete accounting solution tx returns for individuals & businesses GST & BAS lodgement bookkeeping & payroll. We specilise in tasks from small to large, from a simple tax return to corporate restructure.</i></p>
     <p className="card-text"><i>With an experience of more than a year, our qualified team of accountants at Arnican specialise in providing financial managements solutions.</i></p>   
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            </section> 
        </div>
    )
}
